import { DASHBOARD_DATA } from '../constants/routes';
import AuthService from './authservices';
import { DashboardApiResponse, DashboardDataRequest } from '../types/dashboard';

const authService = new AuthService();

export const fetchDashboardData = async ({
  username,
  selectedSport,
}: DashboardDataRequest): Promise<DashboardApiResponse> => {
  const requestUrl = new URL(DASHBOARD_DATA);

  requestUrl.searchParams.set('username', username);
  requestUrl.searchParams.set('selectedSport', selectedSport);

  const response = await authService.authenticatedFetch(requestUrl.toString(), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch dashboard data');
  }

  return response.json();
};
